import { render, staticRenderFns } from "./EditarRegistro.vue?vue&type=template&id=4cfbfb1e&"
import script from "./EditarRegistro.vue?vue&type=script&lang=js&"
export * from "./EditarRegistro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports